import * as React from 'react';
import Toggle from 'material-ui/Toggle';

const zoom = {zoom: 1.2}
const renderToggle = ({ input, label, ...rest }) => (
  <Toggle
      label={label}
      toggled={Boolean(input.value)}
style={zoom}
      onToggle={input.onChange}
      {...rest}
  />
);

//errorText={touched && error}

export default renderToggle;



// WEBPACK FOOTER //
// ./src/app/components/fields/Toggle.tsx